import { LitEntity, renderIf, html } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-surface';
import '../../common/bn-loading';
import './fmm-integration-overview';
import './microsoft-finance-and-operations-integration-overview';
import './mtech-integration-overview';
import './mtech-protein-integration-overview';
import './fas-integration-overview';

class IntegrationsList extends LitEntity {
  static get styles() {
    return sharedStyles;
  }

  render() {
    if (this.loading) {
      return html`<bn-loading></bn-loading>`;
    }

    if (!this.entity) {
      return html``;
    }

    const integrationItems = this.entity.getSubEntitiesByClass('item');
    return html`
      ${integrationItems.map((item) => html`
        <bn-surface>
          ${renderIf(item.class.includes('mtech-sonar-integration'), () => html`
            <mtech-integration-overview
              title="${item.title}"
              .href="${item.href}"
            ></mtech-integration-overview>
          `)}
          ${renderIf(item.class.includes('mtech-protein-integration'), () => html`
            <mtech-protein-integration-overview
              title="${item.title}"
              .href="${item.href}"
            ></mtech-protein-integration-overview>
          `)}
          ${renderIf(item.class.includes('fmm-integration'), () => html`
            <fmm-integration-overview
              title="${item.title}"
              .href="${item.href}"
            ></fmm-integration-overview>
          `)}
          ${renderIf(item.class.includes('fas-integration'), () => html`
            <fas-integration-overview
              title="${item.title}"
              .href="${item.href}"
            ></fas-integration-overview>
          `)}
          ${renderIf(item.class.includes('microsoft-finance-and-operations-integration'), () => html`
            <microsoft-finance-and-operations-integration-overview
              title="${item.title}"
              .href="${item.href}"
            ></microsoft-finance-and-operations-integration-overview>
          `)}
        </bn-surface>
      `)}
    `;
  }
}

window.customElements.define('integrations-list', IntegrationsList);
